import React from "react";
import { Instagram, AtSign, Music2 } from "lucide-react";

const items = [
    {
        key: "instagram",
        name: "Instagram",
        handle: "@leonardthepreacher1",
        url: "https://instagram.com/leonardthepreacher1",
        Icon: Instagram,
        accent: "bg-hotpink",
        textColor: "text-hotpink",
    },
    {
        key: "threads",
        name: "Threads",
        handle: "@leonardthepreacher1",
        url: "https://threads.net/@leonardthepreacher1",
        Icon: AtSign,
        accent: "bg-skyblue",
        textColor: "text-skyblue",
    },
    {
        key: "tiktok",
        name: "TikTok",
        handle: "@leonardthepreacher",
        url: "https://tiktok.com/@leonardthepreacher",
        Icon: Music2,
        accent: "bg-kickgreen",
        textColor: "text-kickgreen",
    },
];

export const SocialsSection = () => {
    return (
        <section
            id="socials"
            data-testid="socials-section"
            className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24"
        >
            <div className="mb-10">
                <p className="font-graffiti text-hotpink text-2xl -rotate-2 mb-1">
                    follow the wave ↓
                </p>
                <h2 className="font-anton uppercase text-4xl md:text-6xl text-white leading-none">
                    Catch Me <span className="text-skyblue">Everywhere</span>
                </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {items.map(({ key, name, handle, url, Icon, accent, textColor }, i) => (
                    <a
                        key={key}
                        data-testid={`social-${key}`}
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        className={`group block bg-black border-4 border-black brutal-shadow p-6 hover:-translate-y-1 hover:translate-x-1 transition-transform ${
                            i % 2 === 0 ? "rotate-[-1deg]" : "rotate-[1deg]"
                        }`}
                    >
                        <div className="flex items-center gap-4">
                            <div
                                className={`w-14 h-14 ${accent} border-2 border-black flex items-center justify-center group-hover:rotate-12 transition-transform`}
                            >
                                <Icon className="w-7 h-7 text-black" strokeWidth={2.5} />
                            </div>
                            <div>
                                <div className="font-anton uppercase tracking-wider text-2xl text-white">
                                    {name}
                                </div>
                                <div
                                    className={`font-graffiti text-lg ${textColor} -rotate-1`}
                                >
                                    {handle}
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 pt-4 border-t-2 border-white/10 font-chivo text-xs uppercase tracking-widest text-white/40 group-hover:text-white transition-colors">
                            Tap to follow →
                        </div>
                    </a>
                ))}
            </div>
        </section>
    );
};
